import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Seo from "../../components/Seo";
import { LoadingState, ErrorState } from "../../components/StateBlocks";
import { completeLogin, startLogin } from "../../utils/cognitoAuth";
import useAuth from "../../hooks/useAuth";

export default function AdminLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, refresh } = useAuth();
  const [status, setStatus] = useState("idle"); // idle | exchanging | error
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) return;

    setStatus("exchanging");
    // Remove the authorization code from the URL/history immediately.
    window.history.replaceState({}, "", "/admin/login");

    completeLogin(code)
      .then(() => {
        refresh();
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        setStatus("error");
        setErrorMessage(err.message || "Sign-in failed. Please try again.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthenticated && status === "idle") {
    navigate("/admin", { replace: true });
    return null;
  }

  return (
    <>
      <Seo title="Organizer Login" description="Sign in to manage HS Library Hangout events." />
      <h1>Organizer login</h1>
      <p>This page is for HS Library Hangout organizers only.</p>

      {status === "exchanging" && <LoadingState label="Signing you in\u2026" />}
      {status === "error" && <ErrorState message={errorMessage} onRetry={() => setStatus("idle")} />}
      {status === "idle" && (
        <button type="button" className="btn btn-primary" onClick={startLogin}>
          Sign in with organizer account
        </button>
      )}
    </>
  );
}
